/**
 * UnsupportedMessage Component
 *
 * Renders messages with unsupported or unknown message types.
 * Displays a user-friendly message indicating the message type is not supported.
 */

import React, { FC } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
import { BaseMessageProps } from "../../types/MessageTypes"

const UnsupportedMessage: FC<BaseMessageProps> = ({
  message,
  bgChat,
  txChat,
  isTabletOrMobile,
}) => {
  const { t } = useTranslation()

  const maxWidthClass = isTabletOrMobile ? "mw-200px" : "mw-lg-300px"

  return (
    <div
      style={{ color: txChat }}
      className={clsx("p-5 rounded fw-bold", bgChat, maxWidthClass)}
    >
      <span
        className="bi bi-exclamation-triangle-fill"
        style={{ paddingRight: "5px" }}
      />
      <span style={{ fontStyle: "italic" }}>
        {t("HC.Error.Unsupportedmsg")}
      </span>
    </div>
  )
}

export default UnsupportedMessage
